export const findLargestImageUrl = (images) => {
  const firstImage = images[0];
  const variants = firstImage.attributes.variants;
  const largestImage = Object.values(variants).reduce(
    (acc, curr) => {
      if (curr.width > acc.width) return curr;
      return acc;
    },
    { url: '', width: 0 }
  );
  return largestImage.url;
};

export const getListingImages = (listing) => {
  const images = listing.images || [];
  if (!images.length) return [];
  return images.map((img) => ({
    type: 'image',
    value: findLargestImageUrl([img]),
  }));
};

export const getDetailsList = ({
  listing: {
    attributes: {
      publicData: {
        categoryLevel1,
        dataRepresentationType,
        geoLocation,
        madeWith,
        pointCloudFileSizeMb,
        scanType,
      },
    },
  },
  listingConfig: { listingFields },
}) => {
  const normalizeText = (text) => {
    const options = listingFields.flatMap((curr) => curr.enumOptions || []);
    return options.find((lf) => lf.option === text)?.label;
  };
  return [
    {
      label: 'Scan type:',
      value: normalizeText(scanType),
    },
    {
      label: 'Category:',
      value: categoryLevel1,
    },
    {
      label: 'Data representation type:',
      value: normalizeText(dataRepresentationType),
    },
    {
      label: 'Geo-location:',
      value: normalizeText(geoLocation),
    },
    {
      label: 'Made with:',
      value: normalizeText(madeWith),
    },
    {
      label: 'Scan size (Mb):',
      value: pointCloudFileSizeMb,
    },
  ];
};

export const normalizeTags = (listing) => {
  const tags = listing?.attributes?.publicData?.tags;
  if (tags.length < 1) return null;
  const normalizedString = tags.reduce((acc, curr) => {
    const comaMaybe = tags.indexOf(curr) < tags.length - 1 ? ', ' : '';
    return acc + curr + comaMaybe;
  }, '');
  return normalizedString;
};
